import React from 'react';

const HalfSun = ({
    xmlns='http://www.w3.org/2000/svg',
    width = 58,
    height = 19,
}: React.SVGProps<SVGSVGElement>) => (
    <svg width={width} height={height} viewBox="0 0 58 19" fill="none" xmlns={xmlns}>
        <path d="M28.9658 3.10823e-07C22.9518 0.000705198 17.0576 1.68239 11.9486 4.85526C6.83959 8.02813 2.71914 12.5659 0.0522805 17.9563C0.0144818 18.0323 -0.00333488 18.1167 0.000514001 18.2015C0.00436289 18.2863 0.0297487 18.3687 0.0742772 18.4409C0.118806 18.5132 0.181007 18.5729 0.255016 18.6145C0.329026 18.656 0.412406 18.678 0.497284 18.6785H57.4383C57.5237 18.6784 57.6076 18.6564 57.6821 18.6147C57.7567 18.5729 57.8192 18.5127 57.8638 18.4399C57.9085 18.3671 57.9337 18.284 57.9371 18.1987C57.9405 18.1133 57.922 18.0285 57.8833 17.9524C55.2159 12.5618 51.0947 8.02423 45.9849 4.85198C40.8751 1.67974 34.9802 -0.000834448 28.9658 3.10823e-07Z" fill="#FFE636"/>
    </svg>
);

export default HalfSun;